var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import { OverlayView, Marker } from '@react-google-maps/api';
import PopUpInfo from '../../vehiclePopUpInfo/PopUpInfo';
import PinDropIcon from '@material-ui/icons/PinDrop';

var MarkerService = function (_Component) {
    _inherits(MarkerService, _Component);

    function MarkerService(props) {
        _classCallCheck(this, MarkerService);

        var _this = _possibleConstructorReturn(this, (MarkerService.__proto__ || Object.getPrototypeOf(MarkerService)).call(this, props));

        _initialiseProps.call(_this);

        _this.state = {
            position: {
                lat: _this.props.position.lat,
                lng: _this.props.position.lng
            },
            clusterer: _this.props.clusterer,
            isShown: true,
            class1: '',
            backgroundColor: '',
            popUpInfo: false
        };

        return _this;
    }

    /* se invoca justo antes de llamar al método de render, 
    tanto en la montura inicial como en las actualizaciones posteriores. 
    Debes devolver un objeto para actualizar el estado, o nulo para actualizar nada. */


    _createClass(MarkerService, [{
        key: 'render',
        value: function render() {
            return React.createElement(
                Marker,
                {
                    position: this.state.position,
                    clusterer: this.state.clusterer,
                    visible: false,
                    onVisibleChanged: this.showMarkerContent
                    // icon={{path: 'google.maps.SymbolPath.CIRCLE', scale: 0}}
                    , icon: { path: '' }
                },
                this.state.isShown && React.createElement(
                    OverlayView,
                    {
                        key: Math.random(),
                        position: this.state.position,
                        mapPaneName: OverlayView.OVERLAY_MOUSE_TARGET,
                        getPixelPositionOffset: this.getPixelPositionOffset
                    },
                    React.createElement(
                        'div',
                        null,
                        React.createElement(PinDropIcon, { style: { cursor: "pointer" }, onClick: this.onClick, fontSize: 'large', className: this.state.class1 }),
                        React.createElement(
                            'div',
                            { id: 'vehicle', className: 'vehicle', style: { display: this.state.popUpInfo ? "block" : "none" } },
                            React.createElement(PopUpInfo, { destiny: this.props.content.destinatario })
                        )
                    )
                )
            );
        }
    }]);

    return MarkerService;
}(Component);

MarkerService.getDerivedStateFromProps = function (props) {
    var _ref = '',
        class1 = _ref.class1,
        backgroundColor = _ref.backgroundColor;

    if (props.content.idETipoEstadoTipoServicio === 2) {
        // Finalizado
        class1 = 'svgPinIconGreen';
        // stateIconClass = 'newIcon-destino_hecho'
        // borderColor = 'content-green-borderbg';
        // backgroundColor = 'content-green-bg'
    }
    if (props.content.idETipoEstadoTipoServicio === 1) {
        // en proceso
        class1 = 'svgPinIconYellow';
        // stateIconClass = 'newIcon-destino_posible_retraso'
        // borderColor = 'content-yellow-borderbg';
        // backgroundColor = 'content-yellow-bg';
    }

    return {
        position: {
            lat: props.position.lat,
            lng: props.position.lng
        },
        class1: class1,
        backgroundColor: backgroundColor
    };
};

var _initialiseProps = function _initialiseProps() {
    var _this2 = this;

    this.showMarkerContent = function () {
        _this2.setState({
            isShown: !_this2.state.isShown
        });
    };

    this.getPixelPositionOffset = function (width, height) {
        return {
            x: -(width / 2),
            y: -(height / 2)

        };
    };

    this.onClick = function () {
        _this2.setState({
            popUpInfo: !_this2.state.popUpInfo
        });
        // document.getElementById("vehicle").style.display = "block";
        // console.log("hola")
    };
};

export default MarkerService;